import React, { FC, useEffect } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Accordion from 'react-bootstrap/Accordion'
import Button from 'react-bootstrap/Button'
import ChangePassword from '../../../components/Member/ChangePassword'
import useChangePassword from '../../../hooks/authentication/useChangePassword'
import useUserWithRole from '../../../hooks/authentication/useUserWithRole'
import isAuthenticated from '../../../routes/PrivateRoute'
import useAccount from '../../../hooks/admin/useAccount'
import useEnvironment from '../../../hooks/location/useEnviroment'
import PageTitle from '../../../components/PageTitle'
import './index.scss'

const initialPasswordValues = {
  currentPassword: '',
  password: '',
  passwordAgain: ''
}

const MemberAccount: FC = () => {
  const { data: environmentData } = useEnvironment()
  const { user, role } = useUserWithRole()
  const { data: accountInfo, refetch: refetchAccount } = useAccount(user?.pid)
  const userChangePassword = useChangePassword()

  useEffect(() => {
    if (role === 'member') {
      refetchAccount()
    }
  }, [role])

  return (
    <section className='content'>
      <Container>
        <PageTitle displayName="My Account" />
        <Row>
          <Col sm={6}>
            <h1 className='headerText h2 mb-0'>My Account</h1>
          </Col>
          <Col sm={12}>
            <section className='dataContainer'>
              <dl>
                <h2 className='fw-bold pt-2 pb-2 h6'>ACCOUNT DETAILS</h2>
                <Row>
                  <Col sm={3}>
                    <dt>Username</dt>
                  </Col>
                  <Col sm={9}>
                    <dd>
                      {user.sub}
                    </dd>
                  </Col>
                </Row>
                <Row>
                  <Col sm={3}>
                    <dt>Email</dt>
                  </Col>
                  <Col sm={9}>
                    <dd>
                      {user?.email}
                    </dd>
                  </Col>
                </Row>
                {role === 'member' && (
                  <>
                    <Row>
                      <Col sm={3}>
                        <dt>Proxy</dt>
                      </Col>
                      <Col sm={9}>
                        <dd>
                          {accountInfo?.isProxy ? 'Y' : 'N'}
                        </dd>
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={3}>
                        <dt>Proxy Name</dt>
                      </Col>
                      <Col sm={9}>
                        <dd>
                          {accountInfo?.proxyFirstName || ''} {accountInfo?.proxyLastName || ''}
                        </dd>
                      </Col>
                    </Row>
                  </>
                )}
                <h2 className="fw-bold pt-3 pb-3 h6">CHANGE PASSWORD</h2>
                <Accordion className="custom-password-accordion" flush>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="p-0 bg-transparent border-0">
                      <Row className="w-100 align-items-center">
                        <Col sm={3}>
                          <dt className="mb-0">Change Password</dt>
                        </Col>
                        <Col sm={9}>
                          <Button className="btn-primary px-3 py-1">
                            Change Password
                          </Button>
                        </Col>
                      </Row>
                    </Accordion.Header>
                    <Accordion.Body className="mb-2 p-0">
                      <div className="password-form-wrapper mt-2">
                        <ChangePassword
                          userId={user.sub}
                          changePassword={userChangePassword}
                          initialValues={initialPasswordValues}
                        />
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

              </dl>
            </section>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default isAuthenticated(MemberAccount)